import { toast } from "react-toastify"

import { ErrorCodeAndText, Errors } from "@/types"

export function formatErrorMessage(status: string | number, error?: { name: string } & ErrorCodeAndText) {
  return `Status: ${status}${error ? `; ${error.code}: "${error.name}" ${error.text}` : ""}`
}

export function getFirstError(errors: Errors) {
  const entries = Object.entries(errors)
  if (!entries.length) return null

  const [errorName, errorBody] = entries[0]

  return { name: errorName, code: errorBody[0]?.code, text: errorBody[0]?.text }
}

export function handleStandardError(response: Response, json?: { errors?: Errors }) {
  if (!json?.errors) {
    toast.error(formatErrorMessage(response.status))
    return
  }

  const firstError = getFirstError(json.errors)

  if (!firstError) {
    toast.error(formatErrorMessage(response.status))
    return
  }

  toast.error(formatErrorMessage(response.status, firstError))
}
